import React from 'react';
import Immutable, { List } from 'immutable';
import config from 'react-global-configuration';

import {
  Paragraph,
  Block,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID, DOMAIN_VRIENDEN_REGENBOOG } from '../../../../config/constants';

import './style.scss';

const NodeBasicPage = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const currentDomainIsVriendenRegenboog = config.get('CURRENT_DOMAIN') === DOMAIN_VRIENDEN_REGENBOOG;

  return (
    <article className="NodeBasicPage">
      {/* Start of content */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            {title && <h1 className="NodeBasicPage__title">{title}</h1>}

            {body && (
              <div className="NodeBasicPage__body">
                <WysiwygField property="schema:text" html={body} />
              </div>
            )}
          </div>
        </div>
      </Container>
      {/* End of content */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs', List()).size > 0 ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');

            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

      {!currentDomainIsVriendenRegenboog && (
        <Block id={BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID} />
      )}

    </article>
  );
};

export default NodeBasicPage;
